
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[placeId]/[locale]/[...taxonomy]",
      function () {
        return require("private-next-pages/p/[placeId]/[locale]/[...taxonomy].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[placeId]/[locale]/[...taxonomy]"])
      });
    }
  